import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimePauseIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.59999 1.89999H4.79999C4.52385 1.89999 4.29999 2.12385 4.29999 2.39999V21.6C4.29999 21.8761 4.52385 22.1 4.79999 22.1H9.59999C9.87613 22.1 10.1 21.8761 10.1 21.6V2.39999C10.1 2.12385 9.87613 1.89999 9.59999 1.89999Z"
        fill={color}
      />
      <path
        d="M19.2 1.89999H14.4C14.1239 1.89999 13.9 2.12385 13.9 2.39999V21.6C13.9 21.8761 14.1239 22.1 14.4 22.1H19.2C19.4761 22.1 19.7 21.8761 19.7 21.6V2.39999C19.7 2.12385 19.4761 1.89999 19.2 1.89999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimePauseIcon.displayName = 'TimePauseIcon';
